<template>
  <div>
    <group-card title="Referrer / Supplier" icon="connect_without_contact" padded>
      <template slot="actions">
        <md-button
          class="md-icon-button md-primary md-simple new-app-button"
          @click="onDialogAction(true, 'hubspot_product')"
        >
          <md-icon id="new-app-icon">note_add</md-icon>
          Import Product
          <md-tooltip md-direction="top">Import Product CSV</md-tooltip>
        </md-button>
        <md-button
          class="md-icon-button md-primary md-simple new-app-button"
          @click="onDialogAction(true, 'hubspot_partner')"
        >
          <md-icon id="new-app-icon">note_add</md-icon>
          Import Partner
          <md-tooltip md-direction="top">Import Partner CSV</md-tooltip>
        </md-button>
        <md-button class="md-icon-button md-primary md-simple"
                   @click="$router.push('/administration/user_management/introducer/new')">
          <md-icon>add</md-icon>
          <md-tooltip md-direction="top">Add New Referrer / Supplier</md-tooltip>
        </md-button>
        <loading-icon-button
          @click="getIntroducers(true)"
          tooltip="Refresh"
          :loading="progress_indicator.introducer_list"
        >
          cached
        </loading-icon-button>
      </template>
      <!-- Import CSV Editor -->
      <md-dialog :md-active.sync="upload_csv_dialog.show_dialog">
        <group-card :title="upload_csv_dialog.title" icon="attach_file">
          <ValidationObserver ref="form_upload_template">
            <form enctype="multipart/form-data">
              <div class="md-layout">
                <p>{{ upload_csv_dialog.content }}</p>
              </div>
              <div class="md-layout">
                <!-- CSV Upload -->
                <md-field>
                  <label>Import CSV file only</label>
                  <md-file
                    v-model="upload_csv_dialog.file_name"
                    accept="text/csv"
                    name="file"
                    @change="onFileChange"
                    required
                  />
                </md-field>
              </div>
              <div>
                <md-button class="md-primary md-simple md-danger" @click="onDialogAction(false)">Cancel</md-button>
                <md-button class="md-primary" @click="importHubSpotCSV">Import</md-button>
                <md-progress-spinner
                  v-if="upload_csv_dialog.loading"
                  :md-diameter="30"
                  :md-stroke="3"
                  md-mode="indeterminate" />
              </div>
            </form>
          </ValidationObserver>
        </group-card>
      </md-dialog>
      <div data-app>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-data-table
          :headers="introducerHeader"
          :items="introducers"
          :search="search"
          item-key="name"
          :items-per-page="10"
          class="elevation-0 introducer_table"
          :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'first_page',
                    lastIcon: 'last_page',
                    prevIcon: 'skip_previous',
                    nextIcon: 'skip_next'}"
          :loading="progress_indicator.introducer_list"
          loading-text="Loading... Please wait"
        >
          <template v-slot:item.actions="{ item }">
            <loading-icon-button
              @click="viewIntroducer(item)"
              tooltip="Open"
            >
              launch
            </loading-icon-button>
          </template>

          <template v-slot:item.trigger_1="{item}">
            <span class="trigger">{{ item.trigger_1 }}</span>
            <p class="rate" v-if="item.trigger_type == 'percentage'">{{ item.rate_1 | suffix('%') }}</p>
            <p class="rate" v-else>{{ item.rate_1 | currency }}</p>
          </template>
        </v-data-table>
      </div>
    </group-card>
  </div>
</template>
<script>
import filters from "@/components/utils/filters";
import {GroupCard} from "@/components";
import {mapGetters} from "vuex";
import LoadingIconButton from '@/components/LoadingIconButton';
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";

export default {
  components: {
    GroupCard,
    LoadingIconButton,
    ConfirmDialog
  },
  data() {
    return {
      introducers: [],
      search: '',
      progress_indicator: {
        introducer_list: false,
      },
      introducerHeader: [
        {text: 'ID', value: "id"},
        {
          text: "Referrer Code",
          align: 'start',
          sortable: true,
          value: 'introducer_code'
        },
        {text: 'Contact Name', value: 'full_name'},
        {text: 'Email', value: 'email'},
        {text: 'Trading Name', value: 'trading_name'},
        {text: 'Contact Number', value: 'contact_number'},
        {text: 'Opted in to CS', value: 'referral_opted_cs'},
        {text: 'Referral Agreement', value: 'referral_agreement'},
        {text: 'New Lead Notification', value: 'referral_new_lead_notification'},
        {text: 'State', value: 'state'},
        {text: 'Postcode', value: 'post_code'},
        {text: 'Associated Broker', value: 'bdm_broker'},
        {text: 'Trigger 1', value: 'trigger_1'},
        {text: 'Trigger 2', value: 'trigger_2'},
        {text: 'Trigger 3', value: 'trigger_3'},
        {text: 'Trigger 4', value: 'trigger_4'},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      upload_csv_dialog: {
        show_dialog: false,
        title: 'Import CSV',
        file_name: '',
        file: null,
        loading: false,
        content: '',
        type: '',
      },
    }
  },
  methods: {
    async getIntroducers(force = false) {
      this.progress_indicator.introducer_list = true
      var response = await this.$store.dispatch('fetch_administration_introducers', force);
      if (response) {
        this.introducers = this.savedIntroducers();
      }
      this.progress_indicator.introducer_list = false
    },
    viewIntroducer(item) {
      this.$router.push(`/administration/user_management/introducer/${item.id}/view`)
    },
    onDialogAction(show = false, type = '') {
      if (type == 'hubspot_partner') {
        this.upload_csv_dialog.content = 'Upload CSV from HubDB partner table.';
      } else if (type == 'hubspot_product') {
        this.upload_csv_dialog.content = 'Upload CSV from HubSpot Product table.';
      }
      this.upload_csv_dialog.type = type;
      this.upload_csv_dialog.file_name = '';
      this.upload_csv_dialog.file = null;
      this.upload_csv_dialog.show_dialog = show;
    },
    onFileChange(event) {
      this.upload_csv_dialog.file = event.target.files[0];
    },
    async importHubSpotCSV() {
      this.upload_csv_dialog.loading = true;
      const response = await this.$store.dispatch('import_hubspot_csv', {
        file: this.upload_csv_dialog.file,
        type: this.upload_csv_dialog.type,
      })
      if (response.status == 200) {
        await this.showConfirmDialog("Success", "Upload CSV Successfully.");
        this.upload_csv_dialog.show_dialog = false;
      } else {
        const message = response.message.error.map( e => {
          return `<p>row ${e['index']}: ${e['message']}</p>`;
        }).join('');
        this.showConfirmDialog("Error", message);
      }
    },
    async showConfirmDialog(title, message) {
      this.upload_csv_dialog.loading = false;
      return await this.$modal.show(ConfirmDialog, {
        title: title,
        message: message,
        confirmText: "Close",
      })
    },
  },
  created() {
    this.getIntroducers(true)
  },
  computed: {
    ...mapGetters({
      savedIntroducers: 'administrationIntroducers',
    }),
  },
  filters: {
    ...filters,
  }
}
</script>
<style lang="scss" scoped>
.introducer_table {
  table {
    td {
      text-align: center;
    }
  }

  .v-data-footer__select {
    display: none;
  }
}
.rate{
  font-weight: bold;
}
.trigger{
  color:dimgrey;
  font-size: 10px;
}
</style>

